import React from 'react';
import styled from 'styled-components';
import { black, gray } from '@avangard/ui/colors';
import { breakpoints } from '@avangard/ui/utils';

type ProfileCardRowProps = {
    label: string;
    children: React.ReactElement | string;
};

const Root = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    padding: 12px 0;

    ${breakpoints.down('xs')} {
        flex-direction: column;
        align-items: flex-start;
    }

    & > * {
        width: 50%;
        flex: 0 0 auto;

        ${breakpoints.down('xs')} {
            width: 100%;
        }
    }

    &:not(:last-child) {
        border-bottom: 1px solid ${gray[30]};
    }
`;

const Label = styled.div`
    font-size: 1.2em;
    line-height: 1.4;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: ${black[54]};

    ${breakpoints.down('xs')} {
        font-size: 1em;
        margin-bottom: 4px;
    }
`;

const Value = styled.div`
    font-size: 1.4em;
    line-height: 1.4;
    letter-spacing: 0.15px;
    color: ${black[80]};
    word-break: break-word;
`;

const ProfileCardRow = (props: ProfileCardRowProps): React.ReactElement => {
    const { label, children } = props;

    return (
        <Root>
            <Label>{label}</Label>
            <Value>{children}</Value>
        </Root>
    );
};

export { ProfileCardRow };
